export default (theme) => ({
  container: {
    color: theme.palette.primary.main,
    padding: theme.spacing(5),
    "& a": {
      color: theme.palette.primary.main,
    },
  },
});
